// Détection des fautes de frappe dans le domaine d'une adresse e-mail.
// On ne bloque JAMAIS l'envoi : un domaine d'entreprise rare peut ressembler à une faute.
// On propose une correction, la famille garde le dernier mot.

// Domaines réellement utilisés par les familles de l'école (Suisse romande + grands fournisseurs).
const DOMAINES = [
  "gmail.com", "hotmail.com", "hotmail.fr", "hotmail.ch", "outlook.com", "outlook.fr",
  "live.com", "live.fr", "msn.com", "yahoo.com", "yahoo.fr", "icloud.com", "me.com",
  "bluewin.ch", "sunrise.ch", "netplus.ch", "hispeed.ch", "vtxnet.ch", "romandie.com",
  "swissonline.ch", "gmx.ch", "gmx.net", "gmx.com", "protonmail.com", "proton.me",
  "infomaniak.ch", "citycable.ch", "sefanet.ch", "worldcom.ch", "span.ch",
];

// Extensions mal tapées : la faute la plus fréquente, et la plus facile à corriger sans risque.
const TLD_FAUTES = {
  con: "com", cm: "com", comm: "com", cmo: "com", ocm: "com", cim: "com", vom: "com",
  fr1: "fr", frr: "fr", hc: "ch", cj: "ch", chh: "ch", "c h": "ch",
};

// Damerau-Levenshtein : l'inversion de deux lettres (gmial → gmail) compte pour UNE faute,
// pas deux. C'est la faute de frappe la plus fréquente sur un clavier.
function distance(a, b) {
  if (a === b) return 0;
  if (Math.abs(a.length - b.length) > 2) return 3;
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 0; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cout = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cout);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
  }
  return d[a.length][b.length];
}

// Renvoie l'adresse corrigée si une faute probable est détectée, sinon "".
export function suggestionEmail(email) {
  const valeur = String(email || "").trim().toLowerCase();
  const at = valeur.lastIndexOf("@");
  if (at < 1 || at === valeur.length - 1) return "";
  const local = valeur.slice(0, at);
  const domaine = valeur.slice(at + 1);
  if (!domaine.includes(".")) return "";
  if (DOMAINES.includes(domaine)) return "";

  // 1. Extension mal tapée (gmail.con, bluewin.hc…)
  const morceaux = domaine.split(".");
  const tld = morceaux[morceaux.length - 1];
  if (TLD_FAUTES[tld]) {
    const corrige = [...morceaux.slice(0, -1), TLD_FAUTES[tld]].join(".");
    return `${local}@${corrige}`;
  }

  // 2. Domaine proche d'un domaine connu (gnail.com, gmial.com, hotmial.fr…)
  //    Seuil serré : 1 faute sur un domaine court, 2 sur un domaine long.
  let meilleur = "";
  let meilleureDistance = 99;
  for (const connu of DOMAINES) {
    const d = distance(domaine, connu);
    const limite = connu.length <= 10 ? 1 : 2;
    if (d > 0 && d <= limite && d < meilleureDistance) {
      meilleureDistance = d;
      meilleur = connu;
    }
  }
  return meilleur ? `${local}@${meilleur}` : "";
}
